import CheckboxControl from '@/components/controls/checkbox-control';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Form } from '@/components/ui/form';
import { Loader2Icon } from 'lucide-react';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type FormValues = {
  humidity: boolean;
  pollution: boolean;
  party: boolean;
  class: boolean;
  industry: boolean;
  selection: boolean;
};

interface DialogAnalysisProps {
  openDialog: boolean;
  setOpenDialog: (a: boolean) => void;
  onSave: any;
  formAnalysis: any;
  isLoading: boolean;
}

export function DialogAnalysis({
  openDialog,
  setOpenDialog,
  onSave,
  formAnalysis,
  isLoading,
}: DialogAnalysisProps) {
  const form = useForm<FormValues>({
    defaultValues: {
      humidity: false,
      pollution: false,
      party: false,
      class: false,
      industry: false,
      selection: false,
    },
  });

  const checkboxValues = useMemo(() => {
    return (
      Object.entries(form.watch())?.filter(([key, value]) => value).length === 2
    );
  }, [form.watch()]);
  const formEl = formAnalysis.getValues();

  const { t } = useTranslation();
  return (
    <Form {...form}>
      <Dialog onOpenChange={setOpenDialog} open={openDialog}>
        <DialogContent className="sm:max-w-[625px]">
          <DialogHeader>
            <DialogTitle>{t('confirm')}</DialogTitle>
            <DialogDescription className="text-lg">
              {t('data.not.saved')}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <CheckboxControl name="pollution" control={form.control} />
              <div className="w-full flex justify-between items-center">
                <p className="text-nowrap">{t('pollution')}</p>
                <div className="w-full border-b border-dashed h-6" />
                <span className="text-nowrap font-medium">
                  {formEl?.pollution ? `${formEl?.pollution}%` : '---'}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <CheckboxControl name="humidity" control={form.control} />
              <div className="w-full flex justify-between items-center">
                <p className="text-nowrap">{t('humidity')}</p>
                <div className="w-full border-b border-dashed h-6" />
                <span className="text-nowrap font-medium">
                  {formEl?.humidity ? `${formEl?.humidity}%` : '---'}
                </span>
              </div>
            </div>
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline"> {t('cancel')}</Button>
            </DialogClose>
            <Button
              type="button"
              onClick={onSave}
              disabled={!checkboxValues || isLoading}
            >
              {isLoading && <Loader2Icon className="animate-spin" />}
              {t('save')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Form>
  );
}
